import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import { useConfiguration } from '~/context/common/StaticContext';
import isEmpty from '~/utilities/isEmpty';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper, Label } from './FiltersMenu.styles';

export default function Features() {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const { enableUuidFeatureFiltering = false } = useConfiguration();
  const facetData = useFacetData();
  const uuidFeaturesAvailable =
    enableUuidFeatureFiltering && !isEmpty(facetData.cvnaFeatureDetails);
  const facetKey = uuidFeaturesAvailable
    ? 'cvnaFeatureDetails'
    : 'cvnaFeatures';
  const filterKey = uuidFeaturesAvailable ? 'cvnaFeatureIds' : 'cvnaFeatures';
  const features = facetData[facetKey] ?? {};
  const appliedFeatures = appliedFilters[filterKey];

  return (
    <FilterDrawer
      testId="facet-features"
      facetContent={features}
      facetName="Features"
    >
      <div className="grid gap-4xl">
        {Object.keys(features).map(category => {
          return (
            <div key={category}>
              <Label>{category}</Label>
              <CommonWrapper>
                {features[category].map(
                  ({ count, displayName, key: feature }) => (
                    <Checkbox
                      analyticsAttributes={{ category }}
                      checked={appliedFeatures?.includes(feature)}
                      facet={filterKey}
                      filter={feature}
                      id={`features-${displayName}`}
                      key={feature}
                      label={
                        showInventoryCounts
                          ? `${displayName} (${count.toLocaleString()})`
                          : displayName
                      }
                      onChange={() =>
                        updateListFilter({
                          filterKey,
                          value: feature
                        })
                      }
                    />
                  )
                )}
              </CommonWrapper>
            </div>
          );
        })}
      </div>
    </FilterDrawer>
  );
}
